import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Avatar, Box, Center, Separator, Flex, HStack, Heading, Icon, Spinner, Stack, Text, VStack } from '@chakra-ui/react';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { ListNavDotIndicator } from '@src/components/sco/Education/VideoLessonsListNav/ListNavDotIndicator';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { SSRGate } from '@src/components/sco/utilities/SSRGate';
import { gql } from '@src/lib/gql';
import { useParams } from 'next/navigation';
import React from 'react';
import { MdPlayArrow } from 'react-icons/md';
type VideoLessonsListNavProps = {};
export const VideoLessonsListNav = props => {
  const $ = _c(29);
  const routeParams = useParams();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = VideoLessonsListNav.queries.videoList();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = routeParams?.videoListSlug;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      variables: {
        videoListSlug: t1
      }
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const query = useQuery(t0, t2);
  const educationContext = useEducationContext();
  useBreakpointContext();
  const t3 = `/videos/${query.data?.videoList?.slug}`;
  const t4 = query.data?.videoList?.title;
  let t5;
  if ($[3] !== t4) {
    t5 = <Heading color="colorPalette.fg" fontWeight={700} lineHeight="shorter" size="lg">{t4}</Heading>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== t5) {
    t6 = <NextLink href={t3} prefetch={false}>{t5}</NextLink>;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <HStack gap={3} width="full"><Box flex={1}><Text color="colorPalette.fg/50" textStyle="label2xs">with</Text></Box><Separator borderColor="colorPalette.border" width="full" /></HStack>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== query.data?.videoList?.people) {
    t8 = query.data?.videoList?.people && query.data?.videoList?.people.map((expert, index) => {
      query.data?.videoList?.people.length;
      return <Stack key={index} align="center" direction="row" gap={2} width="full"><Avatar.Root size="sm"><Avatar.Fallback /><Avatar.Image src={expert.avatar.url} /></Avatar.Root><Text color="colorPalette.fg" fontWeight={600} textStyle="md">{expert.firstName} {expert.lastName}</Text></Stack>;
    });
    $[9] = query.data?.videoList?.people;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <VStack align="flex-start" gap={3} width="full">{t7}{t8}</VStack>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t9) {
    t10 = <VStack align="flex-start" gap={2} padding={3} width="full"><Box width="full"><VStack align="flex-start" bgColor="colorPalette.container" border="1px solid" borderColor="colorPalette.border" borderRadius="xl" boxShadow="base" gap={0} overflow="hidden" width="full"><VStack align="flex-start" gap={4} padding={6} width="full">{t6}{t9}</VStack></VStack></Box></VStack>;
    $[13] = t6;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== query.loading) {
    t11 = query.loading && <Center padding="1em"><Spinner /></Center>;
    $[16] = query.loading;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== query.error) {
    t12 = query.error && <p>{"Error: "}{query.error.message}</p>;
    $[18] = query.error;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== educationContext || $[21] !== query.data?.videoList || $[22] !== routeParams?.videoSlug) {
    t13 = query.data?.videoList && <VStack align="flex-start" gap={1} height="full" overflowY="auto" paddingBottom={3} paddingX={3} width="full">{query.data?.videoList?.videos.map(video => <Box key={video.id} width="full"><NextLink href={`/videos/${query.data?.videoList?.slug}/${video.slug}`}><HStack align="center" borderRadius="md" gap={2} justify="flex-start" padding={2} transition="all 0.2s ease-in" width="full" _hover={{
            bgColor: educationContext.activeContent.item?.id === video.id ? null : "container"
          }} bgColor={educationContext.activeContent.item?.id === video.id ? "colorPalette.emphasized" : null}><SSRGate disableSSR={true}><ListNavDotIndicator isActive={video.slug === routeParams?.videoSlug} viewableId={video.id} viewableType={video.__typename} /></SSRGate><HStack justify="space-between" width="full"><Text _hover={{
                color: "colorPalette.fg"
              }} textStyle="xs" transition="color 0.2s ease-in" color={educationContext.activeContent.item?.id === video.id ? "colorPalette.fg" : "colorPalette.fg/80"}>{video.title}</Text><Flex alignItems="center" gap={0}><Icon asChild={true} boxSize={3} color="colorPalette.fg/50"><MdPlayArrow /></Icon><Text fontSize="2xs" fontWeight={600} color={educationContext.activeContent.item?.id === video.id ? "colorPalette.fg" : "colorPalette.fg/50"}>{Math.round(video.durationInSeconds / 60)}{"m "}{Math.round(video.durationInSeconds % 60)}s</Text></Flex></HStack></HStack></NextLink></Box>)}</VStack>;
    $[20] = educationContext;
    $[21] = query.data?.videoList;
    $[22] = routeParams?.videoSlug;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t12 || $[27] !== t13) {
    t14 = <VStack gap={0} height="full" overflow="hidden" width="full">{t10}{t11}{t12}{t13}</VStack>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
};
VideoLessonsListNav.queries = {
  videoList: () => gql`
    query ($videoListSlug: String) {
      videoList(where: { slug: $videoListSlug }) {
        id
        slug
        title
        people {
          id
          firstName
          lastName
          shortBio
          avatar {
            url
          }
        }
        videos {
          id
          title
          slug
          durationInSeconds
        }
      }
    }
  `
};